/* Libraries */
import styled from 'styled-components';

const PublishAt = styled.p`
  /* Style */
  color: rgba(70, 70, 70, 1); /*Changed gray color*/
  /* Text */
  font-family: var(--main-font-medium);
  font-size: 1.2rem;
  font-style:normal;
`;

export default PublishAt;



// WEBPACK FOOTER //
// ./src/components/Article/PublishAt.js